/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  var $submenuToggler = $('.js-submenu-toggler');
  var $submenuWrapper = $('.js-submenu-wrapper');
  var $submenu = $('.js-submenu');

   $submenuToggler.on('click', function(e) {
    $submenu.toggleClass('js-dn');

     $submenuWrapper.bind('clickoutside', function(e) {
      $submenu.addClass('js-dn');
      $submenuWrapper.unbind('clickoutside');
    });
  });
});
